import { defa }         from 'defa-object';
import InsuranceCompany from 'scripts/defa/insurance-companies/model-insurance-company';

/**
 * defa.collections.InsuranceCompanies
 * A collection of InsuranceCompanies
 * @version 1.2.0
 */

const apiHost            = defa.vars.apiHost;
const api                = {
	insuranceCompanies: apiHost + '/insurance'
};
const InsuranceCompanies = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	url       : api.insuranceCompanies,
	model     : InsuranceCompany,
	comparator: function ( model ) {
		return model.get( 'name' );
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Returns a new InsuranceCompanies collection filtered by an array of ids.
	 * @param  {array}      ids  An array of ids to filter the collection by.
	 * @return {collection}      The filtered InsuranceCompanyCollection.
	 */
	filterByIds: function ( ids ) {
		let array = this.filter( function ( customer ) {
			return _.contains( ids, customer.get( 'id' ) );
		} );
		
		return new InsuranceCompanies( array );
	},
	
	
} );

export default InsuranceCompanies;